import InputLabel from './InputLabel.vue';

// @ts-ignore
InputLabel.install = (Vue) => {
  Vue.component((InputLabel as any).options.name, InputLabel);
};

export default InputLabel;
